const normalizeRole = (role) =>
  String(role || "")
    .trim()
    .toLowerCase()
    .replace(/[\s/-]+/g, "_")
    .replace(/^care_staff$/, "carestaff")
    .replace(/^care_manager$/, "caremanager");

const FIRST_APPROVER_ROLES = {
  home_care: "caregiver",
  senior_living: "carestaff",
  rehab: "rehab_aide",
  primary_care: "care_team",
};

const SECOND_APPROVER_ROLES = {
  home_care: "caremanager",
  senior_living: "caremanager",
  rehab: "pt_ot",
  primary_care: "physician",
};

const SECOND_APPROVER_ROLE_SET = new Set(Object.values(SECOND_APPROVER_ROLES));

export const normalizeActionPlanRole = normalizeRole;

export const getSignoffRole = (role) =>
  SECOND_APPROVER_ROLE_SET.has(normalizeRole(role))
    ? "caremanager"
    : "caregiver";

export const getFirstApproverRole = (tenantType) =>
  FIRST_APPROVER_ROLES[tenantType] || "caregiver";

export const getSecondApproverRole = (tenantType) =>
  SECOND_APPROVER_ROLES[tenantType] || "caremanager";
